import React from "react";
// Components
import { SelectedTypes } from "./Components";

import { useParams } from "react-router-dom";
// Store Utils
import { useSelector } from "react-redux";
import { RootState } from "store";
import { useDispatch } from "react-redux";
import { behaviorsResetFiltersAction } from "store/filters/reducer.actions";
import { filtersInitialState } from "store/filters/initialState";

const AppliedFilters = () => {
  // Getting behaviorsFilter state from Redux store
  const { behaviorsFilter } = useSelector<RootState, filtersInitialState>(
    (state) => state.Filters
  );

  const dispatch = useDispatch();
  const { organizationId, programId, communityId } = useParams<{
    organizationId: string;
    programId: string;
    communityId: string;
  }>();
  // Function to check if any filter is applied

  const clearAllFilters = () => {
    dispatch(behaviorsResetFiltersAction());
  };

 

  return (
    <div className="flex flex-wrap items-start justify-start flex-grow-0 flex-shrink-0 gap-1">
      {isAnyBehaviorFilterApplied(behaviorsFilter) && (
        <button
          onClick={clearAllFilters}
          type="button"
          className="flex items-center justify-center flex-grow-0 gap-1 border-none outline-none focus:outline-none rounded-3xl"
        >
          <div className="flex justify-center items-center flex-grow-0 flex-shrink-0 relative pt-1.5 pb-2">
            <p className="flex-grow-0 flex-shrink-0 text-sm font-semibold text-center text-primary">
              Clear All Filters
            </p>
          </div>
        </button>
      )}
      <div
        style={{ maxWidth: "90%" }}
        className="flex flex-wrap items-center justify-start"
      >
        <div className="flex flex-wrap gap-2">
          <SelectedTypes />
        </div>
      </div>
    </div>
  );
};

export default AppliedFilters;

export function isAnyBehaviorFilterApplied(behaviorsFilter: any): boolean {
  const { dateAdded, typeIds, categoryIds, communityIds } = behaviorsFilter;
  const applied = typeIds?.applied;

  return applied;
}
